import { useFlags, useNotifications } from '@fullstory/react-hooks';
import { DashboardRequestActions, useGetAccess } from '@fullstory/redux';
import { useCallback } from 'react';
import { int64 } from '@fullstory/proto/google/protobuf';
import { addToDashboardDeniedMessage } from '../constants';

export const useHasDashboardAccess = () => {
  const flags = useFlags();
  const notifications = useNotifications();
  const getDashboardAccess = useGetAccess(DashboardRequestActions.getAccess, flags);

  const hasDashboardAccess = useCallback(
    async (dashboardId: int64) => {
      try {
        const ids = dashboardId ? { int64Ids: { ids: [dashboardId] } } : undefined;
        const access = await getDashboardAccess(ids);
        if (!access[dashboardId.toString()]?.canUpdate) {
          notifications.error(addToDashboardDeniedMessage);
          return false;
        }
      } catch (e) {
        console.error('Error verifying dashboard access', dashboardId);
        return false;
      }

      return true;
    },
    [getDashboardAccess, notifications],
  );

  return hasDashboardAccess;
};
